import { FogFacility } from '@rcp/types';
import { RestSlice } from 'src/redux/rest.slice';
import { localizationService, Resource } from 'src/services';

export const fogFacilitiesSlice = new RestSlice<FogFacility>(
	localizationService.getLocalizedString('screen.labels.facility'),
	Resource.FogFacilities
);
export const fogFacilitiesSliceReducer = fogFacilitiesSlice.rests.reducer;
